import { Box, Stack } from "@mui/material";
import React, { FunctionComponent } from "react";

import { MaybeNull } from "types";

import { PurchaseActions, PurchasesPagination } from "./components";

interface PdfFooterProps {
  documentId: MaybeNull<number>,
  setScale: React.Dispatch<React.SetStateAction<number>>;
  downloadUrl: MaybeNull<string>;
  actionsDisabled: boolean;
  withPagination?: boolean;
  setScaleChange: React.Dispatch<React.SetStateAction<boolean>>;
  setFileName: any;
  fileName: MaybeNull<string>;
}

export const PurchasePdfFooter: FunctionComponent<PdfFooterProps> = ({
  documentId,
  setScale,
  downloadUrl,
  actionsDisabled,
  withPagination = true,
  setScaleChange,
  setFileName,
  fileName
}) => {
  const handleFileName = (file: any) => {
    setFileName(file);
  }
  

  return (
  <Box
    sx={(theme) => ({
      background: theme.palette.primary.main,
      padding: "12px 24px",
      color: "#ffffff",
    })}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <PurchaseActions
        documentId={documentId}
        actionsDisabled={actionsDisabled}
        downloadUrl={downloadUrl}
        fileName={fileName}
        setScale={setScale}
        setScaleChange={setScaleChange}
        handleFileName={handleFileName}
      />
      {withPagination ? <PurchasesPagination fileName={fileName} /> : null}
    </Stack>
  </Box>
)};
